import { render, staticRenderFns } from "./product-popup-view.vue?vue&type=template&id=867a2b9e&scoped=true&"
import script from "./product-popup-view.vue?vue&type=script&lang=js&"
export * from "./product-popup-view.vue?vue&type=script&lang=js&"
import style0 from "./product-popup-view.vue?vue&type=style&index=0&id=867a2b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867a2b9e",
  null
  
)

export default component.exports